module.exports = __webpack_public_path__ + "media/bootstrap-icons/bug-eddf7065.svg";